export default __webpack_public_path__ + "cd19b0bcf779c5796d66e6bb1c5d470f.png";